module.exports = __webpack_public_path__ + "1bcd19f21d68faa96e87ef0a59dc3633.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_45.jpg
// module id = 1713
// module chunks = 5